<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 400px"
        >
          <div class="modal-content">
            <div class="modal-header">
              <p class="title-modal">User Driver License Details</p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="../../../../assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <div class="user-modal-content">
                <div class="profile-image" v-if="userData">
                  <div class="col-md-12" v-if="camera.isOpen">
                    <p v-if="camera.isLoading">Loading camera...</p>
                    <video v-show="!camera.isLoading && !camera.isTaken" ref="camera" :width="430" :height="350" autoplay></video>
                    <canvas v-show="camera.isTaken" id="photoTaken" ref="canvas" :width="430" :height="350"></canvas>
                    <div class="d-flex justify-content-center">
                      <a :href="DibbleJS.AnchorNoHandlerHref" class="btn-dialog ok-btn text-center" style="padding-top: 20px;" v-text="'Close Camera'" @click="toggleOpenCamera"></a>
                      <a :href="DibbleJS.AnchorNoHandlerHref"
                         @click="takePhoto"
                         class="ml-2 btn-dialog ok-btn text-center"
                         style="padding-top: 20px;"
                         v-if="!camera.isLoading && !camera.isTaken" v-text="'Capture'"></a>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-md-6">
                      <img v-if="user_image" :src="user_image.value" alt="profile-image" width="150">
                      <div v-else>
                          <a v-if="userData.license_image" href="javascript:;"
                             class="images-viewer" v-viewer="{movable: false}">
                                <img :src="userData.license_image" alt="profile-image" width="150">
                          </a>
                        <img v-else src="@/assets/images/image.png" width="150" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <a href="javascript:void(0)" title="Upload new image">
                        <div class="im" style="display: inline-block">
                          <input type="file" value="" @change="addImage" accept="image/*" />
                          <img src="@/assets/images/Icon-upload-blue.svg"/>
                        </div>
                      </a>
                      <a href="javascript:void(0)" title="Use the camera" class="ml-5" @click="toggleOpenCamera">
                        <img src="@/assets/images/Camera-Icon-blue.svg"/>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row mt-2 pl-2 pr-2" v-if="userData">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="license-id">License Number</label>
                      <input type="text" class="form-control" id="license-id" v-model="form.license_id">
                    </div>
                    <div class="form-group">
                      <label for="state" style="text-transform: capitalize">State</label>
                      <select class="form-control"
                              id="item-description-dropdown"
                              v-model="form.license_state">
                        <option v-for="(option, index) in states" :key="index"
                                v-text="option" :value="index"></option>
                      </select>
                    </div>
                    <div class="form-group" v-if="form.license_state === ''">
                      <label for="country" style="text-transform: capitalize">Country</label>
                      <select class="form-control"
                              id="item-description-dropdown"
                              v-model="form.license_country">
                        <option v-for="(option, index) in countries" :key="index"
                                v-text="option" :value="index"></option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center mt-2">
                <button v-text="'Cancel'"
                        class="btn-dialog ok-btn mr-1" @click="closeModal">
                </button>
                <button v-text="'Save'"
                        class="btn-dialog ok-btn" @click="saveUserInfo">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";
import ImageHelper from "@/utils/Image";

export default {
  name: "ModalUserDriverLicense",
	props: {
		userId: String
	},
  data() {
    return {
      DibbleJS: DibbleJS,
      userData: null,
      form: {
        "license_id": "",
        "license_state": "",
        "license_country": "",
      },
      user_image: null,
      mapFields: ['license_id', 'license_state', 'license_country'],
      states: [],
      countries: [],
      camera: {
        isOpen: false,
        isLoading: false,
        isTaken: false
      },
    };
  },
  created() {
    this.getStateAndCountry();
  },
  watch: {
    userData() {
      this.mapFields.forEach(field => {
        this.form[field] = this.userData[field];
      });
    },
  },
  methods: {
    getStateAndCountry() {
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        request: DibbleAPI.api.getStateList,
      }, (response) => {
        if (DibbleAPI.isResponseSuccess(response)) {
          this.states = response.states
          this.states[""] = "Outside of the USA";
          DibbleJS.callApiRequest({
            request: DibbleAPI.api.getCountryList,
          }, (response) => {
            DibbleJS.hideLoader()
            if (DibbleAPI.isResponseSuccess(response)) {
              this.countries = response.countries
              delete this.countries['US']
              this.getUserData()
            }
          })
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    getUserData() {
      this.isLoadingData = true;
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        request: DibbleAPI.api.getUserLicense,
        user_id: this.userId
      }, (response) => {
        DibbleJS.hideLoader()
        this.isLoadingData = false;
        if (DibbleAPI.isResponseSuccess(response)) {
          this.userData = response
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    saveUserInfo() {
      if (!this.form.license_id) {
        DibbleJS.toastErrorMessage('Please fill the License Number');
        return false;
      }

      const params = {
          request: DibbleAPI.api.saveUserLicense,
          user_id: this.userId,
          license_number: this.form.license_id,
          license_state: this.form.license_state,
          license_country: this.form.license_country
      };

      if (this.user_image) {
          params['license_image'] = this.user_image.value
      }

      DibbleJS.showLoader()
      DibbleJS.callApiRequest(params, (response) => {
        DibbleJS.hideLoader()
        if (DibbleAPI.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message)
        } else {
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    addImage (input) {
      const files = input.target.files;
      if (files && files.length > 0) {
        for (let i = 0;i < files.length;i++) {
          const reader = new FileReader();
          const file = files[i];
          if (file.type.indexOf('image') < 0) {
            DibbleJS.toastErrorMessage("Invalid image type.");
            return false;
          }

          let image = {}
          image.name = file.name;

          reader.onload = (e) => {
            console.log(e);
          };

          reader.readAsDataURL(files[i]);
          ImageHelper.resizeImage({ file: files[i], maxSize: 1200 }).then((resizedImage) => {
            const newReader = new FileReader();
            newReader.readAsDataURL(resizedImage);
            newReader.onloadend = () => {
              image.value = newReader.result;
              this.user_image = image;
            }
          }).catch((err) => {
            console.error(err);
          });
        }
      }
    },
    toggleOpenCamera() {
      if(this.camera.isOpen) {
        this.camera.isOpen = false;
        this.camera.isTaken = false
        this.stopCameraStream();
      } else {
        this.camera.isOpen = true;
        this.createCameraElement();
      }
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    createCameraElement() {
      this.camera.isLoading = true;
      if (typeof navigator.mediaDevices != 'undefined') {
        navigator.mediaDevices
          // .getUserMedia({video: { facingMode: { exact: "environment" } }})
          .getUserMedia({video: { facingMode: "environment" } })
          .then(stream => {
            this.camera.isLoading = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            console.log(error)
            this.camera.isLoading = false;
            this.camera.isOpen = false;
            alert("This browser is not support camera1.");
          });
      } else {
        this.camera.isOpen = false;
        this.camera.isLoading = false;
        alert("This browser is not support camera.");
      }
    },
    takePhoto() {
      this.camera.isTaken = !this.camera.isTaken;
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 430, 350);

      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");

      let image = {}
      image.name = "";
      image.value = canvas;
      this.toggleOpenCamera()
      this.user_image = image;
    },
    _onRequestFailed(error) {
      this.isLoadingData = false
      DibbleJS.hideLoader();
      console.log(error)
      this.closeModal()
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    closeModal() {
      this.newNote = "";
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #C2D8DD !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
  .user-modal-content {
    max-height: 500px;
    overflow: scroll;
  }
</style>
